import { axiosInstance } from "../../../axios/axiosInstance";

const API_FLASH_MESSAGES_URL = "admin/flash-message";
const API_FLASH_MESSAGES_MODULE_LIST_URL = API_FLASH_MESSAGES_URL + "/list";
const CREATE_FLASH_MESSAGES_MODULE_LIST_URL = API_FLASH_MESSAGES_URL + "/create";
const API_GET_FLASH_MESSAGE_BY_ID_MODULE_URL = API_FLASH_MESSAGES_URL + "/view";
const UPDATE_FLASH_MESSAGES_MODULE_LIST_URL = API_FLASH_MESSAGES_URL + "/update";
const DELETE_FLASH_MESSAGES_MODULE_LIST_URL = API_FLASH_MESSAGES_URL + "/update-status";

export const getFlashMessages = (dataToBeSent) => {
  return axiosInstance.get(`${API_FLASH_MESSAGES_MODULE_LIST_URL}?page=${dataToBeSent?.page || ""}&limit=${dataToBeSent?.limit || ""}&search=${dataToBeSent?.search || ""}`);
};

export const getFlashMessageById = (dataToBeSent) => {
  return axiosInstance.get(API_GET_FLASH_MESSAGE_BY_ID_MODULE_URL + "/" + dataToBeSent?.selectedFlashMessageId);
};

export const createFlashMessages = (dataToBeSent) => {
  return axiosInstance.post(CREATE_FLASH_MESSAGES_MODULE_LIST_URL, dataToBeSent);
};

export const deleteFlashMessageById = (dataToBeSent) => {
  return axiosInstance.patch(DELETE_FLASH_MESSAGES_MODULE_LIST_URL + "/" + dataToBeSent?.selectedFlashMessageId, {
    is_active : false
  });
};

export const updateFlashMessages = (dataToBeSent) => {
  return axiosInstance.post(UPDATE_FLASH_MESSAGES_MODULE_LIST_URL + "/" + dataToBeSent?._id, dataToBeSent);
};